module.exports = __webpack_public_path__ + "static/media/McDonald'sBanner.237c00e2.png";